import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, SITE } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, duration: 0.5, type: "spring" }}
    data-testid="whatsapp-float-button"
    href={waLink(`Buongiorno ${SITE.shortName}, vorrei maggiori informazioni su un veicolo in catalogo.`)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chatta su WhatsApp"
    className="fixed bottom-6 right-6 z-50 group"
  >
    <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-20" />
    <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-emerald-500 group-hover:bg-emerald-400 text-white shadow-2xl transition-transform group-hover:scale-105">
      <MessageCircle className="w-6 h-6" />
    </span>
    <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap glass border border-border text-xs text-gray-200 px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
      Chatta su WhatsApp
    </span>
  </motion.a>
);
